import { FieldInterval } from "@crispico/foundation-react/entity_crud/CrudSettings";
import { EntityDescriptor, FieldDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { Utils } from "@crispico/foundation-react/utils/Utils";
import moment from "moment";
import React, { ReactElement } from "react";
import { Icon, StrictTableProps, Table } from "semantic-ui-react";
import { AppMetaTempGlobals } from "../AppMetaTempGlobals";
import { Optional } from "../CompMeta";

// CC: put here because if added in ED I received a cycle error
// duplicate constant FieldWidget
export const FIELDS_LAST_UPDATE = "fieldsLastUpdate";

export interface CrudViewerProps {
    entity: any,
    entityDescriptor: EntityDescriptor,
    fields: string[],
    onRowClick?: (field: string) => void;
    renderFunctionsForAdditionalColumns?: ((fieldDescriptor: FieldDescriptor) => ReactElement | null)[];
    maxFields?: number,
    showEmpty?: boolean,
    hideFieldsWithLastUpdateDateEmpty?: boolean,
    tableProps?: StrictTableProps
}

export class CrudViewer<P extends CrudViewerProps = CrudViewerProps> extends React.Component<P> {

    constructor(props: P) {
        super(props);
    }

    renderRow(props: CrudViewerProps, field: string, numberOfFields: number) {
        const hasFieldsLastUpdate = props.entity && props.entity[FIELDS_LAST_UPDATE];
        if (props.maxFields && numberOfFields > props.maxFields) {
            return null;
        }
        const fd = props.entityDescriptor.getFieldDescriptorChain(field)[0];
        if (!fd) {
            return null;
        }
        const value = fd.getFieldValue(props.entity);
        if (!props.showEmpty && Utils.isNullOrEmpty(value)) {
            // ignore empty fields
            return null;
        }
        let lastUpdateDate;
        if (hasFieldsLastUpdate) {
            lastUpdateDate = props.entity[FIELDS_LAST_UPDATE][field];
            if (props.hideFieldsWithLastUpdateDateEmpty && !lastUpdateDate) {
                return null;
            }
        }
        return <Table.Row key={numberOfFields}  onClick={() => this.props.onRowClick && this.props.onRowClick(field)}>
            <Table.Cell key={"name"} ><div className="flex-container-row flex-wrap">{fd.getIcon()}{fd.getLabel()}</div></Table.Cell>
            <Table.Cell style={fd.getFieldColors(value)} className="flex-justify-content-center" key={"value"}>{fd.renderField(props.entity)}</Table.Cell>
            {hasFieldsLastUpdate ? <Table.Cell textAlign='center' key={"lastUpdate"}>{lastUpdateDate ? moment(lastUpdateDate.split("[")[0]).format(Utils.dateTimeWithSecFormat) : null}</Table.Cell> : null}
            {props.renderFunctionsForAdditionalColumns?.map(render => <Table.Cell textAlign='center' key={"additional_" + fd.name}>{render(fd)}</Table.Cell>)}
        </Table.Row>
    }

    render() {
        const props = this.props;
        let numberOfFields = 0;
        return props.entity && <div><Table celled padded selectable compact striped {...props.tableProps}>
            <Table.Body>
                {props.fields.map((field) => {
                    return this.renderRow(props, field, numberOfFields++);
                })}
            </Table.Body>
        </Table>
            {props.maxFields && numberOfFields > props.maxFields ? <p>{_msg("general.displaying", props.maxFields + " " + _msg({pluralized: true}, "general.field").toLocaleLowerCase(), numberOfFields)}</p> : null}
        </div>;
    }
}
